/**
 * Fix for Facebook, Instagram browsing error
 */

window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){}
